<template>
  <div class="container-md">
    <div class="row justify-content-center">
      <div class="body col-auto">
        <div class="py-3 text-center">
          <h3>{{ $t("provisionalEntry.title") }}</h3>
        </div>
        <form class="border bg-light pb-2" @submit.prevent="submit" novalidate>
          <div class="text-center">
            <p class="text-muted px-3 pt-2">{{ $t("provisionalEntry.message") }}</p>
          </div>
          <div class="p-2">
            <input type="email" class="form-control" id="email" v-model="inputEmail" @blur="validateEmail" :placeholder="$t('common.email')">
          </div>
          <div class="d-grid gap-2 p-2 mt-2">
            <button type="submit" class="btn btn-primary" :disabled="isButtonDisabled">
            <div class="text-center" v-if="!isButtonDisabled">
              {{ $t("provisionalEntry.submit") }}
            </div>
            <div class="text-center" v-if="isButtonDisabled && postResult === ''">
              {{ $t("provisionalEntry.loading") }}
            </div>
            <div class="text-center" v-if="isButtonDisabled && postResult === 'success'">
              {{ $t("provisionalEntry.complete") }}
            </div>
            </button>
          </div>
        </form>
      </div>
      <div class="text-center p-2">
        <p class="text-success mb-0" v-if="postResult === 'success'">{{ $t("provisionalEntry.postSuccess", { email: sentEmail }) }}</p>
        <p class="text-success mt-0" v-if="postResult === 'success'">{{ $t("provisionalEntry.postSuccessBr") }}</p>
        <p class="text-danger" v-if="postResult === 'error'">{{ $t("provisionalEntry.postError") }}</p>
        <p class="text-danger" v-if="isEmailError">{{ $t("provisionalEntry.error") }}</p>
        <router-link to="/">{{ $t("common.login") }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Const from '../const'
import axios from 'axios'
import reCaptchaMixin from "../mixins/reCaptchaMixin";

export default {
  mixins:[reCaptchaMixin],
  data() {
    return {
      inputEmail: "",
      sentEmail: "",
      postResult: "",
      isEmailError: false,
      isButtonDisabled: false
    }
  },
  methods: {
    async submit() {
      this.isButtonDisabled = true
      this.validateEmail()

      if (this.isEmailError) {
        this.isButtonDisabled = false
        return
      }

      // reCaptchaからトークンを取得
      let recaptchaToken = "";
      try {
        recaptchaToken = await this.getRecaptchaToken()
      } catch(error) {
        this.postResult = "error"
        this.isButtonDisabled = false;
        return;
      }

      axios.post(Const.BASE_URL + "/email-verification", {
        to_address: this.inputEmail,
        recaptcha_token: recaptchaToken
      })
      .then(function() {
        this.sentEmail = this.inputEmail
        this.postResult = "success"
        // console.log(response)
      }.bind(this))
      .catch(function() {
        this.postResult = "error"
        this.isButtonDisabled = false
        // console.log(error)
      }.bind(this))

    },

    validateEmail() {
      this.postResult = ""
      const regexpEmail = new RegExp(Const.REGEXP_FOR_EMAIL)

      if (!this.inputEmail || !regexpEmail.test(this.inputEmail)) {
        this.isEmailError = true
      } else {
        this.isEmailError = false
      }
    }
  }
}
</script>

<style scoped>
.body {
  height: 100%;
  padding-top:128px;
}
</style>
